import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=5065914c"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports